import cn from 'classnames';
import { useState } from 'react';

import ArrowRightShortIcon from '../SVGIcons/ArrowRightShortIcon';
import CloseIcon from '../SVGIcons/CloseIcon';
import classes from './about-work-card.module.scss';
import { ITechWorkCard } from './AboutWorkCard.type';

function AboutWorkCard({ title, subtitle, description }: ITechWorkCard) {
  const [flipped, setFlipped] = useState(false);

  const handleFlip = () => {
    setFlipped((prev) => !prev);
  };

  return (
    <div className={classes.card}>
      <div
        className={cn(classes.cardContent, {
          [classes.hidden]: !flipped,
          [classes.visible]: flipped,
        })}
      >
        <CloseIcon
          className={classes.close}
          fill="#1D1D1D"
          onClick={handleFlip}
        />
        <div className={classes.cardSubtitle}>{description}</div>
      </div>
      <div
        role="presentation"
        className={cn(classes.cardContent, {
          [classes.hidden]: flipped,
          [classes.visible]: !flipped,
          [classes.flippable]: !!description,
        })}
        onClick={() => {
          if (description) handleFlip();
        }}
      >
        <div className={classes.cardHeader}>
          <p className={classes.heading}>{title}</p>

          <div>{description && <ArrowRightShortIcon />}</div>
        </div>

        <div className={classes.cardSubtitle}>{subtitle}</div>
      </div>
    </div>
  );
}

export default AboutWorkCard;
